/* EDELHOLZ Kaufbox: 3D und "In deinem Raum ansehen" (10.09.2026, Nachbesserung 13:40 nach Philipps Test)
   - Handy: EIN Tipp oeffnet die Kamera. iOS <a rel="ar"> mit USDZ (Quick Look), Android Scene-Viewer-Intent mit GLB.
   - Desktop: "In 3D ansehen" oeffnet den Betrachter auf Studio-Buehne, mit Groessen-Chips zum Umschalten.
     Die Chips wechseln nur die Ansicht, nicht die Konfiguration (Hinweis steht im Kopf).
   - Modell = "<Groesse> / <Holzart>" wie die Alt-Texte der 3D-Medien. Smoked Amber faellt auf Midnight Noir
     derselben Groesse zurueck. Beim Modellwechsel bleibt der Betrachter unsichtbar, bis das neue Modell geladen ist
     (vorher blitzte das alte Modell auf). Unter dem Knopf steht mobil hoechstens eine Zeile. */
(function () {
  'use strict';
  var wurzel = document.querySelector('[data-mk-3d]');
  var datenTag = document.querySelector('[data-mk-3d-modelle]');
  if (!wurzel || !datenTag) return;
  /* Quelle: "kaufbox" (Standard, Produktseite) oder "b" (Konfigurator B). */
  var QUELLE = wurzel.getAttribute('data-mk-3d-quelle') || 'kaufbox';
  var btn = wurzel.querySelector('[data-mk-3d-btn]');
  var label = wurzel.querySelector('[data-mk-3d-label]');
  var hinweis = wurzel.querySelector('[data-mk-3d-hinweis]');
  var frage = wurzel.querySelector('[data-mk-3d-frage]');
  var modal = document.querySelector('[data-mk-3d-modal]');
  /* Das Modal haengt im Markup in der Galerie (eigener Stapelkontext, die Kaufbox daneben lag darueber, z. B. die
     Trusted-Shops-Sterne). Deshalb ans Ende von <body> haengen, dort gilt der z-index ohne Nachbarn. */
  if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);
  var modalHinweis = modal ? modal.querySelector('[data-mk-3d-modal-hinweis]') : null;
  var modalTitel = modal ? modal.querySelector('[data-mk-3d-modal-titel]') : null;
  var chips = modal ? modal.querySelector('[data-mk-3d-groessen]') : null;
  var laedt = modal ? modal.querySelector('[data-mk-3d-laedt]') : null;
  var modelle = {}; var keys = []; var modellName = '';
  function bModell() {
    var t = document.querySelector('.eh-model-cardV.is-selected .eh-modelV-title');
    return t ? t.textContent.trim() : '';
  }
  /* Modelle laden: Kaufbox = ein Block; B = Block des gewaehlten Tischmodells (data-mk-3d-modell). */
  function modelleLaden() {
    var tag = datenTag;
    if (QUELLE === 'b' || QUELLE === 'berater') {
      /* 15.10.: Quelle "berater" = Berater-Ergebnis, Modell/Groesse/Holz stehen als Attribute an der Wurzel (assets/edelholz-berater.js) */
      modellName = QUELLE === 'berater' ? (wurzel.getAttribute('data-mk-3d-modell') || '') : bModell();
      var t = document.querySelector('[data-mk-3d-modelle][data-mk-3d-modell="' + modellName + '"]');
      tag = t || datenTag; if (!t && tag) modellName = tag.getAttribute('data-mk-3d-modell') || '';
      wurzel.setAttribute('data-mk-3d-produkt', modellName || 'EDELHOLZ');
    }
    try { modelle = JSON.parse(tag.textContent) || {}; } catch (e) { modelle = {}; }
    keys = Object.keys(modelle);
  }
  modelleLaden();
  if (!keys.length) return;

  var ua = navigator.userAgent || '';
  var istAndroid = /android/i.test(ua);
  var istIOS = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  var kannAR = istAndroid || istIOS;
  var ERSATZ_FINISH = 'midnightnoir';

  function normal(s) { return String(s || '').toLowerCase().replace(/\s+/g, '').replace(/×/g, 'x'); }
  function teile(key) { var t = key.split('/'); return { groesse: normal(t[0]), finish: normal(t.slice(1).join('/')), groesseText: t[0].trim(), finishText: t.slice(1).join('/').trim() }; }

  /* Auswahl aus der Kaufbox: aktiver Groessen-Chip und aktiver Holzart-Swatch. */
  function auswahl() {
    if (QUELLE === 'berater') return { groesse: normal(wurzel.getAttribute('data-mk-3d-groesse')), finish: normal(wurzel.getAttribute('data-mk-3d-finish')) };
    if (QUELLE === 'b') {
      var bc = document.querySelector('[data-role="size-list"] .eh-chip.is-selected');
      var bs = document.querySelector('[data-role="finish-list"] .eh-swatch.is-selected');
      return { groesse: bc ? normal(bc.textContent) : '', finish: bs ? normal(bs.getAttribute('data-finish') || (bs.querySelector('.eh-swatch-cap') || bs).firstChild.textContent) : '' };
    }
    var chip = document.querySelector('[data-mk-size].aktiv');
    var sw = document.querySelector('[data-mk-finish].aktiv');
    return { groesse: chip ? normal(chip.getAttribute('data-mk-size')) : '', finish: sw ? normal(sw.getAttribute('data-mk-finish')) : '' };
  }
  /* 1. Groesse + Holzart, 2. Groesse in Midnight Noir, 3. Groesse in irgendeiner Holzart, 4. Holzart in erster Groesse, 5. erstes Modell. */
  function passendes(a) {
    var i, t;
    for (i = 0; i < keys.length; i++) { t = teile(keys[i]); if (t.groesse === a.groesse && t.finish === a.finish) return { key: keys[i], ersatz: false, andereGroesse: false }; }
    for (i = 0; i < keys.length; i++) { t = teile(keys[i]); if (t.groesse === a.groesse && t.finish === ERSATZ_FINISH) return { key: keys[i], ersatz: true, andereGroesse: false }; }
    for (i = 0; i < keys.length; i++) { t = teile(keys[i]); if (t.groesse === a.groesse) return { key: keys[i], ersatz: true, andereGroesse: false }; }
    for (i = 0; i < keys.length; i++) { t = teile(keys[i]); if (t.finish === a.finish) return { key: keys[i], ersatz: false, andereGroesse: true }; }
    for (i = 0; i < keys.length; i++) { t = teile(keys[i]); if (t.finish === ERSATZ_FINISH) return { key: keys[i], ersatz: true, andereGroesse: true }; }
    return { key: keys[0], ersatz: true, andereGroesse: true };
  }
  function androidIntent(glb, titel) {
    if (String(glb).indexOf('//') === 0) glb = 'https:' + glb; /* 15.10.: Shopify liefert die Quelle protokoll-relativ, Scene Viewer braucht https */
    return 'intent://arvr.google.com/scene-viewer/1.0?file=' + encodeURIComponent(glb) + '&mode=ar_only&title=' + encodeURIComponent(titel || 'EDELHOLZ') +
      '#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=' + encodeURIComponent(location.href) + ';end;';
  }
  /* Eine Zeile unter dem Knopf. */
  function kurzHinweis(wahl) {
    var f = teile(wahl.key).finishText;
    if (kannAR) return wahl.ersatz ? 'In deinen Raum stellen, als ' + f + '.' : 'Stell ihn in deinen Raum, echte Größe.';
    return 'Dreh ihn, zoom rein, schau dir die Details an.';
  }
  function langHinweis(wahl, gewuenscht) {
    var t = teile(wahl.key); var s = 'Drehen mit der Maus, zoomen mit dem Scrollrad.';
    if (wahl.ersatz) s += ' ' + (gewuenscht || 'Diese Holzart') + ' gibt es in 3D noch nicht, du siehst ' + t.finishText + '. Maße und Proportionen stimmen.';
    if (wahl.andereGroesse) s += ' Gezeigt wird die Größe ' + t.groesseText + '.';
    return s;
  }
  /* Holzarten aus der Kaufbox (Name + Kachelbild), fuer die runden Toggles im Betrachter. */
  function holzarten() {
    var liste = [];
    if (QUELLE === 'berater') {
      try { liste = JSON.parse(wurzel.getAttribute('data-mk-3d-holzarten') || '[]') || []; } catch (e) { liste = []; }
      return liste.map(function (h) { return { wert: h.wert, slug: normal(h.wert), bild: h.bild || '' }; });
    }
    if (QUELLE === 'b') {
      document.querySelectorAll('[data-role="finish-list"] .eh-swatch').forEach(function (sw) {
        var cap = sw.querySelector('.eh-swatch-cap'); var th = sw.querySelector('.eh-swatch-thumb');
        var wert = (sw.getAttribute('data-finish') || (cap && cap.firstChild ? cap.firstChild.textContent : '') || '').trim(); var bg = th ? (th.style.backgroundImage || '') : ''; var m = bg.match(/url\(["']?([^"')]+)["']?\)/);
        if (wert) liste.push({ wert: wert, slug: normal(wert), bild: m ? m[1] : '' });
      });
      return liste;
    }
    document.querySelectorAll('[data-mk-finish]').forEach(function (sw) {
      if (sw.getAttribute('data-mk-finish-extra') && sw.getAttribute('data-mk-finish-extra') !== '0') return;
      var img = sw.querySelector('img'); var wert = sw.getAttribute('data-mk-finish') || '';
      liste.push({ wert: wert, slug: normal(wert), bild: img ? img.getAttribute('src') : '' });
    });
    return liste;
  }
  function holzartName(slug) { var h = holzarten().filter(function (x) { return x.slug === slug; })[0]; return h ? h.wert : ''; }

  /* ansicht = was der Betrachter zeigt. Folgt der Kaufbox, bis man im Betrachter eine andere Groesse antippt. */
  var ansicht = null;
  var aktuell = null;

  function knopfSetzen() {
    modelleLaden(); if (!keys.length) { btn.hidden = true; return; } btn.hidden = false;
    var a = auswahl(); var wahl = passendes(a); var e = modelle[wahl.key]; if (!e) return;
    var titel = wurzel.getAttribute('data-mk-3d-produkt') || 'EDELHOLZ';
    if (kannAR) {
      if (label) label.textContent = 'In deinem Raum ansehen';
      if (istAndroid && e.glb) { btn.setAttribute('href', androidIntent(e.glb, titel)); btn.removeAttribute('rel'); }
      else if (e.usdz) { btn.setAttribute('href', e.usdz); btn.setAttribute('rel', 'ar'); }
    } else {
      if (label) label.textContent = 'In 3D ansehen';
      btn.setAttribute('href', '#3d'); btn.removeAttribute('rel');
    }
    if (hinweis) hinweis.textContent = kurzHinweis(wahl);
    if (frage) frage.textContent = kannAR ? 'Stell ihn in Originalgröße in deinen Raum.' : 'Dreh ihn, zoom rein, bis ins Detail.';
    wurzel.setAttribute('data-mk-3d-aktiv', wahl.key);
  }

  function viewer() { return modal ? modal.querySelector('model-viewer') : null; }
  /* Ladeabdeckung: deckt die Buehne komplett ab (gleicher Verlauf), bleibt mindestens 500 ms und blendet dann weich aus,
     waehrend das neue Modell einblendet. So kann kein altes Modell und kein Vorschaubild durchblitzen (Philipp 10.09.). */
  var ladeUhr = null; var ladeSeit = 0; var MIN_ABDECKUNG = 500; var ladeNr = 0;
  function ladeZustand(an) {
    var mv = viewer(); if (!mv) return;
    clearTimeout(ladeUhr);
    if (an) {
      ladeNr += 1; ladeSeit = Date.now(); mv.classList.add('laedt');
      if (laedt) { laedt.classList.remove('weg'); laedt.hidden = false; }
      var meine = ladeNr;
      ladeUhr = setTimeout(function () { if (meine === ladeNr) ladeZustand(false); }, 15000);
    } else {
      var rest = Math.max(0, MIN_ABDECKUNG - (Date.now() - ladeSeit)); var nr = ladeNr;
      ladeUhr = setTimeout(function () {
        if (nr !== ladeNr) return; /* inzwischen ein neuer Wechsel: dessen Abdeckung bleibt */
        mv.classList.remove('laedt');
        if (laedt) { laedt.classList.add('weg'); setTimeout(function () { if (nr === ladeNr && laedt.classList.contains('weg')) laedt.hidden = true; }, 450); }
      }, rest);
    }
  }
  /* Ist das gewuenschte Modell schon geladen (gleiche Quelle, Cache), Abdeckung direkt loesen. */
  function fertigWennGeladen(mv, ziel) {
    var ist = String(mv.getAttribute('src') || ''); if (ist !== ziel) return;
    if (mv.loaded) ladeZustand(false);
  }
  function chipsBauen() {
    if (!chips || !ansicht) return;
    var wahl = passendes(ansicht); var fin = teile(wahl.key).finish;
    var gesehen = {}; var liste = [];
    keys.forEach(function (k) { var t = teile(k); if (t.finish !== fin || gesehen[t.groesse]) return; gesehen[t.groesse] = true; liste.push(t); });
    /* Nach Breite sortieren, die Medienreihenfolge im Produkt ist beliebig. */
    liste.sort(function (x, y) { return (parseInt(x.groesse, 10) || 0) - (parseInt(y.groesse, 10) || 0); });
    var html = '<span class="eh-mk__3d-gruppe">';
    liste.forEach(function (t) { html += '<button type="button" class="eh-mk__3d-chip' + (t.groesse === teile(wahl.key).groesse ? ' aktiv' : '') + '" data-mk-3d-groesse="' + t.groesse + '">' + t.groesseText + '</button>'; });
    html += '</span>';
    /* Runde Holzart-Toggles: nur Holzarten, fuer die es Modelle gibt. */
    var vorhanden = {}; keys.forEach(function (k) { vorhanden[teile(k).finish] = true; });
    var toggles = holzarten().filter(function (h) { return vorhanden[h.slug]; });
    if (toggles.length > 1) {
      html += '<span class="eh-mk__3d-gruppe eh-mk__3d-gruppe--holz">';
      toggles.forEach(function (h) { html += '<button type="button" class="eh-mk__3d-fin' + (h.slug === fin ? ' aktiv' : '') + '" data-mk-3d-finish="' + h.slug + '" title="' + h.wert + '" aria-label="' + h.wert + '">' + (h.bild ? '<img src="' + h.bild + '" alt="">' : '') + '</button>'; });
      html += '</span>';
    }
    chips.innerHTML = html;
  }
  function modellLaden() {
    modelleLaden();
    var mv = viewer(); if (!mv || !ansicht) return;
    var wahl = passendes(ansicht); var e = modelle[wahl.key]; if (!e) return;
    aktuell = { wahl: wahl, eintrag: e };
    var gewuenscht = wahl.ersatz ? holzartName(ansicht.finish) : '';
    if (modalTitel) {
      modalTitel.textContent = (wurzel.getAttribute('data-mk-3d-produkt') || '') + ' · ' + teile(wahl.key).groesseText + ' · ' + teile(wahl.key).finishText;
      if (wahl.ersatz && gewuenscht) { var tag = document.createElement('span'); tag.className = 'eh-mk__3d-tag'; tag.textContent = gewuenscht + ' in 3D noch nicht verfügbar'; modalTitel.appendChild(tag); }
    }
    if (modalHinweis) modalHinweis.textContent = langHinweis(wahl, gewuenscht);
    chipsBauen();
    mv.setAttribute('alt', wahl.key);
    if (mv.getAttribute('src') !== e.glb) {
      ladeZustand(true);
      mv.setAttribute('src', e.glb); if (e.usdz) mv.setAttribute('ios-src', e.usdz);
      setTimeout(function () { fertigWennGeladen(mv, e.glb); }, 300);
    } else if (mv.loaded) { ladeZustand(false); }
    if (typeof mv.dismissPoster === 'function') { try { mv.dismissPoster(); } catch (x) {} }
  }

  /* 15.09.2026: Das <model-viewer>-Element steht nicht mehr im HTML. Shopifys Feature-Loader (load_feature.js) hatte es
     beim Seitenaufruf gefunden und die 3D-Bibliothek (model-viewer.js + vendors~mv.js, three.js) sofort geladen; ohne WebGL
     (viele Handys, Clarity: 20 % der Sitzungen mit Skriptfehler) warf sie "reading 'xr'". Jetzt entsteht das Element erst in
     oeffnen(), und wir laden die Bibliothek selbst: Feature "model-viewer" (Element) + "model-viewer-ui" (Shopifys Huelle,
     Bedienleiste per CSS ausgeblendet). Mobil (Quick Look / Scene Viewer) wird gar nichts geladen. */
  function betrachterBauen() {
    var buehne = modal ? modal.querySelector('.eh-mk__3d-buehne') : null; if (!buehne) return null;
    var mv = buehne.querySelector('model-viewer'); if (mv) return mv;
    mv = document.createElement('model-viewer');
    var attr = { loading: 'eager', reveal: 'auto', 'camera-controls': 'true', 'auto-rotate': 'true', 'auto-rotate-delay': '600', 'rotation-per-second': '18deg',
      'shadow-intensity': '1.1', 'shadow-softness': '0.85', exposure: '1.05', 'environment-image': 'neutral', 'interaction-prompt': 'none',
      'camera-orbit': '-125deg 74deg auto', style: '--poster-color: transparent; background-color: transparent;' };
    Object.keys(attr).forEach(function (k) { mv.setAttribute(k, attr[k]); });
    mv.classList.add('laedt');
    buehne.appendChild(mv); return mv;
  }
  var bibliothek = null;
  function bibliothekLaden(mv) {
    if (bibliothek) return bibliothek;
    bibliothek = new Promise(function (ok) {
      var fertig = false; var done = function (v) { if (!fertig) { fertig = true; ok(v); } };
      var pruefen = function () { if (window.customElements && customElements.get('model-viewer')) done(true); };
      try {
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'model-viewer', version: '1.12' }, { name: 'model-viewer-ui', version: '1.0', onLoad: function () {
            try { if (mv && window.Shopify.ModelViewerUI && !mv.__ehUi) { mv.__ehUi = new window.Shopify.ModelViewerUI(mv); } } catch (x) {}
            pruefen();
          } }]);
        }
      } catch (x) {}
      pruefen();
      if (window.customElements && customElements.whenDefined) { customElements.whenDefined('model-viewer').then(function () { done(true); }); }
      setTimeout(function () { done(!!(window.customElements && customElements.get('model-viewer'))); }, 10000);
    });
    return bibliothek;
  }
  var mvEreignisse = false;
  function ereignisseBinden(mv) {
    if (mvEreignisse || !mv) return; mvEreignisse = true;
    mv.addEventListener('load', function () { if (aktuell && aktuell.eintrag && String(mv.getAttribute('src') || '') !== aktuell.eintrag.glb) return; ladeZustand(false); });
    mv.addEventListener('error', function () { ladeZustand(false); if (modalHinweis) modalHinweis.textContent = 'Das 3D-Modell konnte nicht geladen werden.'; });
  }
  /* Bei geschlossenem Modal (nur wenn der Betrachter schon einmal offen war) den Betrachter unsichtbar schalten und die
     Quelle setzen. So steht beim naechsten Oeffnen nie das alte Modell im Bild. Vor dem ersten Oeffnen gibt es kein Element. */
  function vorbereiten() {
    var mv = viewer(); if (!mv || !ansicht) return;
    var wahl = passendes(ansicht); var e = modelle[wahl.key]; if (!e) return;
    if (mv.getAttribute('src') !== e.glb) { mv.classList.add('laedt'); if (laedt) laedt.hidden = false; mv.setAttribute('src', e.glb); if (e.usdz) mv.setAttribute('ios-src', e.usdz); }
  }
  function oeffnen() {
    if (!modal) return;
    ansicht = auswahl();
    modal.hidden = false; document.documentElement.classList.add('eh-mk-3d-offen');
    var mv = betrachterBauen();
    /* Quelle sofort setzen: das GLB laedt dann parallel zur Bibliothek. */
    if (mv) { ereignisseBinden(mv); ladeZustand(true); modellLaden(); }
    bibliothekLaden(mv).then(function (ok) {
      modellLaden();
      if (!ok && modalHinweis) { ladeZustand(false); modalHinweis.textContent = 'Der 3D-Betrachter konnte nicht geladen werden. Bitte lade die Seite neu.'; }
    });
    var close = modal.querySelector('[data-mk-3d-close]'); if (close) close.focus();
  }
  function schliessen() {
    if (!modal) return; modal.hidden = true; document.documentElement.classList.remove('eh-mk-3d-offen');
    /* 15.10.: im Berater liegt der Hilfsknopf unsichtbar am Seitenende - Fokus dorthin scrollte die Seite nach unten. Der Berater setzt den Fokus selbst. */
    if (QUELLE === 'berater') { try { document.dispatchEvent(new CustomEvent('eh:berater-3d-zu')); } catch (e) {} return; }
    btn.focus();
  }

  btn.addEventListener('click', function (ev) {
    if (kannAR) return; /* Handy: der Link selbst oeffnet Quick Look / Scene Viewer */
    ev.preventDefault(); oeffnen();
  });
  if (modal) {
    modal.addEventListener('click', function (ev) {
      var chip = ev.target.closest('[data-mk-3d-groesse]');
      if (chip) { ansicht = { groesse: chip.getAttribute('data-mk-3d-groesse'), finish: ansicht ? ansicht.finish : auswahl().finish }; modellLaden(); return; }
      var fin = ev.target.closest('[data-mk-3d-finish]');
      if (fin) { ansicht = { groesse: ansicht ? ansicht.groesse : auswahl().groesse, finish: fin.getAttribute('data-mk-3d-finish') }; modellLaden(); return; }
      if (ev.target.closest('[data-mk-3d-close]') || ev.target.hasAttribute('data-mk-3d-backdrop')) schliessen();
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !modal.hidden) schliessen(); });
  }
  /* Auswahlwechsel in der Kaufbox: Knopf und (falls offen) Betrachter folgen. */
  function auswahlGeaendert() { knopfSetzen(); ansicht = auswahl(); if (modal && !modal.hidden) modellLaden(); else vorbereiten(); }
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest('[data-mk-size], [data-mk-finish]')) return;
    setTimeout(auswahlGeaendert, 0);
  });
  if (QUELLE === 'b' && window.MutationObserver) {
    /* B setzt is-selected selbst und stoppt Klick-Ereignisse; darum auf Klassenwechsel der Karten/Chips/Swatches hoeren. */
    var bUhr = null; var bWurzel = document.querySelector('.eh-steps') || document.body;
    new MutationObserver(function (liste) {
      /* Klassenwechsel an Karte/Chip/Swatch ODER Neuaufbau einer der drei Listen (B rendert die Listen neu). */
      var relevant = liste.some(function (m) { var t = m.target; return t && t.matches && (t.matches('.eh-model-cardV, .eh-chip, .eh-swatch') || t.matches('[data-role="model-list"], [data-role="size-list"], [data-role="finish-list"]') || !!t.closest('[data-role="model-list"], [data-role="size-list"], [data-role="finish-list"]')); });
      if (!relevant) return;
      clearTimeout(bUhr); bUhr = setTimeout(auswahlGeaendert, 60);
    }).observe(bWurzel, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
  }
  if (QUELLE === 'berater') {
    /* 15.10.: Schnittstelle fuer den Berater (Shadow DOM, kann den Knopf hier nicht selbst nutzen):
       link() = Ziel fuer den Handy-Link (Quick Look / Scene Viewer), oeffnen() = Desktop-Betrachter, aktualisieren() nach Attributwechsel. */
    window.EhBerater3d = {
      kannAR: kannAR,
      aktualisieren: auswahlGeaendert,
      oeffnen: function () { auswahlGeaendert(); oeffnen(); },
      link: function () {
        modelleLaden(); if (!keys.length) return null;
        var wahl = passendes(auswahl()); var e = modelle[wahl.key]; if (!e) return null;
        var t = teile(wahl.key); var titel = wurzel.getAttribute('data-mk-3d-produkt') || 'EDELHOLZ';
        if (istAndroid && e.glb) return { href: androidIntent(e.glb, titel), rel: '', ersatz: wahl.ersatz, andereGroesse: wahl.andereGroesse, finish: t.finishText, groesse: t.groesseText };
        if (e.usdz) return { href: e.usdz, rel: 'ar', ersatz: wahl.ersatz, andereGroesse: wahl.andereGroesse, finish: t.finishText, groesse: t.groesseText };
        return null;
      }
    };
  }
  knopfSetzen();
})();
